

<dx-data-grid [dataSource]="dataSource"
              [hoverStateEnabled]="true"
              [columnAutoWidth]="true"
              [wordWrapEnabled]="true"
              [allowColumnResizing]="true"
              [columnResizingMode]="'nextColumn'"
              [showRowLines]="true"
              [showBorders]="true"
              (onToolbarPreparing)="onToolbarPreparing($event)">

    <dxo-search-panel placeholder="Suche..." [width]="300" [visible]="true"></dxo-search-panel>


    <dxo-paging [pageSize]="5"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true"
               [allowedPageSizes]="[5, 10, 20, 50]"
               [showInfo]="true"
               infoText="Seite {0} von {1} Seiten ({2} Datensätze)"
               [showNavigationButtons]="true">
    </dxo-pager>


    <dxo-remote-operations [filtering]="true"
                           [sorting]="true" 
                           [paging]="true">
    </dxo-remote-operations>

    <dxi-column dataType="date" format="dd.MM.yyyy" dataField="datum"></dxi-column>
    <dxi-column dataField="text"></dxi-column>
    <dxi-column dataField="benutzerName"></dxi-column>

</dx-data-grid> 
